import type { CSSProperties } from 'react';
import { defaultCameraLook, lookFilter, lookTransform, type CameraLook } from '@rabbitfuel/shared';

/**
 * Bildkorrektur einer Kamera als Stil fuers `<video>`.
 *
 * Bewusst CSS und nicht ein Canvas-Umweg: so kostet die Korrektur den
 * sendenden Handys nichts, alle Ansichten rechnen dieselbe Kette (die in
 * `shared/src/look.ts` steht), und die Tab-Aufnahme des Servers nimmt sie
 * ohne Zusatzarbeit mit auf.
 */
export function videoLook(look: CameraLook | undefined): CSSProperties {
  const value = look ?? defaultCameraLook();
  return { filter: lookFilter(value), transform: lookTransform(value) };
}

/** Der Look einer Quelle, oder die neutrale Voreinstellung. */
export const lookOf = (cameras: Record<string, CameraLook>, sourceId: string | undefined): CameraLook =>
  (sourceId ? cameras[sourceId] : undefined) ?? defaultCameraLook();
